"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenToken = exports.getTokenValue = exports.getIsContainReferenceTokenValue = exports.getIsReferenceValue = exports.getIsLeafOfNestedToken = exports.getIsElevationValue = exports.getIsObject = void 0;
var statics_1 = require("../statics");
var getIsObject = function (obj) {
    return typeof obj === 'object' && !!obj;
};
exports.getIsObject = getIsObject;
var getIsElevationValue = function (obj) {
    return Array.isArray(obj) &&
        obj.every(function (each) { return (0, exports.getIsObject)(each) && each.type === 'dropShadow'; });
};
exports.getIsElevationValue = getIsElevationValue;
var getIsLeafOfNestedToken = function (obj) {
    if (!((0, exports.getIsObject)(obj) &&
        Object.keys(obj).length === 2 &&
        !!obj.value &&
        !!obj.type &&
        typeof obj.type !== 'object')) {
        return false;
    }
    if ((0, exports.getIsElevationValue)(obj.value) || typeof obj.value !== 'object')
        return true;
    throw new Error('Unknown Leaf Token Type.');
};
exports.getIsLeafOfNestedToken = getIsLeafOfNestedToken;
var getIsReferenceValue = function (tokenKey) {
    return (tokenKey.startsWith('{ref') || tokenKey.startsWith('{sys')) && tokenKey.endsWith('}');
};
exports.getIsReferenceValue = getIsReferenceValue;
var getIsContainReferenceTokenValue = function (tokenValue) {
    var refTokenPrefix = '{ref.';
    var sysTokenPrefix = '{sys.';
    return tokenValue.includes(refTokenPrefix) || tokenValue.includes(sysTokenPrefix);
};
exports.getIsContainReferenceTokenValue = getIsContainReferenceTokenValue;
var getTokenValue = function (tokenValue) {
    if ((0, exports.getIsElevationValue)(tokenValue)) {
        return tokenValue
            .map(function (eachValue) {
            return "".concat(eachValue.x, " ").concat(eachValue.y, " ").concat(eachValue.blur, " ").concat(eachValue.spread, " ").concat(eachValue.color);
        })
            .join(',');
    }
    if (typeof tokenValue !== 'string')
        return tokenValue;
    if ((0, exports.getIsContainReferenceTokenValue)(tokenValue)) {
        return tokenValue.replaceAll(/({)(ref|sys).([a-z0-9.-]+)(})/g, "".concat(statics_1.RSPTokenPrefix, ".$2.$3"));
    }
    return tokenValue;
};
exports.getTokenValue = getTokenValue;
var flattenToken = function (obj, keyPrefix) {
    if (!(0, exports.getIsObject)(obj)) {
        throw new Error("Input is ".concat(typeof obj, ", not an object."));
    }
    return Object.keys(obj).reduce(function (flattened, key) {
        var _a;
        var currentKey = keyPrefix ? "".concat(keyPrefix, ".").concat(key) : key;
        var objValue = obj[key];
        var isLeafOfNestedToken = (0, exports.getIsLeafOfNestedToken)(objValue);
        var isObject = (0, exports.getIsObject)(objValue);
        if (isLeafOfNestedToken) {
            var tokenKey = "".concat(statics_1.RSPTokenPrefix, ".").concat(currentKey);
            var tokenValue = (0, exports.getTokenValue)(objValue.value);
            return __assign(__assign({}, flattened), (_a = {}, _a[tokenKey] = tokenValue, _a));
        }
        if (isObject) {
            var flattenedChild = (0, exports.flattenToken)(objValue, currentKey);
            return __assign(__assign({}, flattened), flattenedChild);
        }
        return flattened;
    }, {});
};
exports.flattenToken = flattenToken;
//# sourceMappingURL=flatten-token.js.map